import { defineComponent as U, computed as m, ref as A, useTemplateRef as j, watch as z, openBlock as f, createElementBlock as V, createVNode as w, unref as v, withCtx as I, createBlock as x, Fragment as X, renderList as J, renderSlot as Q, mergeProps as p, toHandlers as B, createTextVNode as W, toDisplayString as Z, createCommentVNode as _ } from "vue";
import "@popperjs/core";
import { RevInputText as ee } from "@ds/components/InputText";
import { RevList as te } from "@ds/components/List";
import { RevListItemAction as ae } from "@ds/components/ListItemAction";
import { RevPopover as le } from "@ds/components/Popover";
import { isEmpty as y } from "../../utils/isEmpty.js";
import { tw as C } from "../../utils/tailwind.js";
import { VariantsEnum as re, OPTIONS_MAX_LENGTH as ne, NO_ACTIVE_OPTION as d } from "./InputAutocomplete.constant.js";
const oe = { class: "relative" }, be = /* @__PURE__ */ U({
  name: "RevInputAutocomplete",
  inheritAttrs: !1,
  __name: "InputAutocomplete",
  props: {
    clearButtonAriaLabel: {},
    description: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    error: { default: () => {
    } },
    helperTextClass: { type: [String, Boolean, Array, Object], default: () => C`mt-8` },
    icon: { default: () => {
    } },
    id: {},
    label: {},
    listboxPlacement: { default: "auto" },
    options: {},
    modelValue: {},
    required: { type: Boolean, default: !1 },
    type: { default: "text" },
    variant: { default: () => re.Floating }
  },
  emits: ["update:model-value", "select-item", "focus", "blur", "input", "clear"],
  setup(a, { emit: P }) {
    const u = P, b = m(() => a.options.slice(0, ne));
    function N(e) {
      return `${a.id}-option-${e}`;
    }
    const o = A(d), g = A(!1), T = m(() => `${a.id}-listbox`), L = j("inputText"), F = m(() => L.value?.inputContainerId);
    function c(e) {
      return e && !y(a.options);
    }
    const h = m({
      get() {
        return a.modelValue;
      },
      set(e) {
        u("update:model-value", e);
      }
    });
    function O(e) {
      if (!(!c(e) || o.value === d))
        return N(o.value);
    }
    z(b, (e) => {
      o.value = y(e) ? d : Math.min(o.value, e.length - 1);
    });
    function R(e, t) {
      t(), u("focus", e);
    }
    function S(e, t) {
      g.value || t(), u("blur", e);
    }
    function K(e) {
      o.value = d, u("input", e);
    }
    function M() {
      u("clear");
    }
    function s(e, t, r, l) {
      if (y(a.options))
        return;
      if (e.preventDefault(), !c(l)) {
        r();
        return;
      }
      const { length: n } = b.value;
      if (t === Number.NEGATIVE_INFINITY) {
        o.value = 0;
        return;
      }
      if (t === Number.POSITIVE_INFINITY) {
        o.value = n - 1;
        return;
      }
      if (o.value === d) {
        o.value = t < 0 ? n - 1 : 0;
        return;
      }
      o.value = (o.value + n + t) % n;
    }
    function $(e) {
      e();
    }
    function q(e, t, r) {
      const l = a.options[o.value];
      !l || !c(r) || (e.preventDefault(), u("select-item", l, a.id, o.value), t());
    }
    function D(e, t, r, l) {
      switch (e.key) {
        case "ArrowDown":
          s(e, 1, t, l);
          break;
        case "PageDown":
        case "End":
          s(e, Number.POSITIVE_INFINITY, t, l);
          break;
        case "ArrowUp":
          s(e, -1, t, l);
          break;
        case "PageUp":
        case "Home":
          s(e, Number.NEGATIVE_INFINITY, t, l);
          break;
        case "Escape":
          $(r);
          break;
        case "Enter":
          q(e, r, l);
          break;
      }
    }
    function Y(e) {
      o.value = e;
    }
    function G() {
      g.value = !0;
    }
    async function H(e, t, r, l, n) {
      e.preventDefault(), u("select-item", t, r, l), n(), g.value = !1;
    }
    function E({ index: e }) {
      return {
        id: N(e),
        index: e,
        role: "option",
        class: e === o.value && C`bg-static-default-min-hover`
      };
    }
    function k({
      index: e,
      option: t,
      hide: r
    }) {
      return {
        click: (l) => H(l, t, a.id, e, r),
        mousedown: () => G(),
        mousemove: () => Y(e)
      };
    }
    return (e, t) => (f(), V("div", oe, [
      w(v(le), {
        "content-class-names": "z-10 w-full",
        position: a.listboxPlacement,
        "trigger-element-id": F.value
      }, {
        trigger: I(({ show: r, hide: l, isOpen: n }) => [
          w(v(ee), p({
            id: a.id,
            ref: "inputText"
          }, e.$attrs, {
            modelValue: h.value,
            "onUpdate:modelValue": t[0] || (t[0] = (i) => h.value = i),
            "aria-activedescendant": O(n),
            "aria-autocomplete": "list",
            "aria-controls": T.value,
            "aria-expanded": String(c(n)),
            autocomplete: "off",
            "clear-button-aria-label": a.clearButtonAriaLabel,
            description: a.description,
            disabled: a.disabled,
            error: a.error,
            "helper-text-class": a.helperTextClass,
            icon: a.icon,
            label: a.label,
            required: a.required,
            role: "combobox",
            type: a.type,
            variant: a.variant,
            onBlur: (i) => S(i, l),
            onClear: M,
            onFocus: (i) => R(i, r),
            onInput: K,
            onKeydown: (i) => D(i, r, l, n)
          }), null, 16, ["id", "modelValue", "aria-activedescendant", "aria-controls", "aria-expanded", "clear-button-aria-label", "description", "disabled", "error", "helper-text-class", "icon", "label", "required", "type", "variant", "onBlur", "onFocus", "onKeydown"])
        ]),
        content: I(({ hide: r, isOpen: l }) => [
          c(l) ? (f(), x(v(te), {
            key: 0,
            id: T.value,
            class: "bg-overlap-default-low shadow-long rounded-sm mt-4 overflow-hidden",
            "has-external-borders": !1,
            role: "listbox"
          }, {
            default: I(() => [
              (f(!0), V(X, null, J(b.value, (n, i) => Q(e.$slots, "default", p({ ref_for: !0 }, {
                ...n,
                ...E({ index: i })
              }, B(k({ option: n, index: i, hide: r }), !0)), () => [
                (f(), x(v(ae), p({
                  key: n.key
                }, { ref_for: !0 }, E({ index: i }), B(k({ option: n, index: i, hide: r }))), {
                  label: I(() => [
                    W(Z(n.label), 1)
                  ]),
                  _: 2
                }, 1040))
              ])), 256))
            ]),
            _: 2
          }, 1032, ["id"])) : _("", !0)
        ]),
        _: 3
      }, 8, ["position", "trigger-element-id"])
    ]));
  }
});
export {
  be as default
};
